import React from "react";
import Header from "../../component/users/Header";
import { useSelector } from "react-redux";
import { Box, Container } from "@mui/material";
import Footer from "../../component/users/Footer";
import MyAccountComponent from "../../component/users/MyAccount";
import MyAccountSkeleton from "../../component/users/Leaderboard/Skeleton";

const Goals = () => {
  const user = useSelector((state) => state.user.loading);
  return (
    <>
      <Header />
      {user ? (
        <MyAccountSkeleton />
      ) : (
        <Box className="userLayout">
          <Container
            disableGutters={true}
            maxWidth="lg"
            sx={{
              background: "#242743",
              paddingBottom: "0px",
              // minHeight: "calc(100% - 56px)",
            }}
          >
            <MyAccountComponent />
            <Footer />
          </Container>
        </Box>
      )}
    </>
  );
};

export default Goals;
